module.exports = __webpack_public_path__ + "static/img/400.2867785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201029/400.jpg
// module id = pT/d
// module chunks = 0